module.exports = __webpack_public_path__ + "img/dashboardac.11bd19d6.svg";